export const getFileExtension = (name: string) => {
  const split = name.split('.');

  return split[split.length - 1];
};

export const createFileWithName = (file: File, newName: string) => {
  return new File([file], newName);
};
